
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/gis-and-land-surveying-resources",
      function () {
        return require("private-next-pages/articles/gis-and-land-surveying-resources.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/gis-and-land-surveying-resources"])
      });
    }
  